function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import DropdownFormField from '../../util/form/DropdownFormField';
import { AddButton } from '../../util/buttons';
import userAccessProjectParticipationsService from '../../services/user_access_project_participations.service';
import userAccessBusinessUnitParticipationsService from '../../services/user_access_business_unit_participations.service';
import userAccessFolderParticipationsService from '../../services/user_access_folder_participations.service';
import userAccessFileParticipationsService from '../../services/user_access_file_participations.service';
import claimGroupService from '../../services/claim_group.service';
import { BusinessUnitSelector } from '../../claim_project_report/BusinessUnitSelector';
import { ProjectSelector } from '../../claim_project_report/ProjectSelector';
import FolderAndFilePicker from '../../folders_and_files/FolderAndFilePicker';
export default function UserProjectAccess(_ref) {
  var _claimGroup$client_up, _claimGroup$claim_pro;
  let {
    userAccess,
    setClientContact,
    company,
    claimGroup,
    setClaimGroup,
    loading,
    setLoading,
    onClaimScheduleClientContactParticipationChange
  } = _ref;
  // may not be defined for all markets
  const claimGroupRootClientAccessableFolderId = ((_claimGroup$client_up = claimGroup.client_uploads_folder) === null || _claimGroup$client_up === void 0 ? void 0 : _claimGroup$client_up.id) || null;
  const {
    t
  } = useTranslation();
  const [selectedAdditionalAccessType, setSelectedAditionalAccessType] = useState(null);
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedFileFolderScope, setSelectedFileFolderScope] = useState(null);
  const [selectedFileFolderProject, setSelectedFileFolderProject] = useState(null);
  const [selectedFileFolderItem, setSelectedFileFolderItem] = useState(null);
  const [localUserAccess, setLocalUserAccess] = useState(_objectSpread({}, userAccess));
  const createUserAccessProjectParticipation = userAccessProjectParticipationsService.useCreateUserAccessProjectParticipationFromClaimGroup(claimGroup, setClaimGroup, setLoading);
  const createUserAccessBusinessUnitParticipation = userAccessBusinessUnitParticipationsService.useCreateUserAccessBusinessUnitParticipationFromClaimGroup(claimGroup, setClaimGroup, setLoading);
  const createUserAccessFolderParticipation = userAccessFolderParticipationsService.useCreateUserAccessFolderParticipationFromClaimGroup(claimGroup, setClaimGroup, setLoading);
  const createUserAccessFileParticipation = userAccessFileParticipationsService.useCreateUserAccessFileParticipationFromClaimGroup(claimGroup, setClaimGroup, setLoading);
  useEffect(() => {
    const updatedUserAccess = claimGroup.user_accesses.find(ua => ua.id === userAccess.id);
    if (updatedUserAccess) {
      setLocalUserAccess(_objectSpread({}, updatedUserAccess));
    }
  }, [claimGroup, userAccess.id]);
  const selectedProjectParticipations = localUserAccess.user_access_project_participations || [];
  const alreadySelectedProjects = selectedProjectParticipations.map(participation => participation.claim_project_report).filter(Boolean);
  const projectSelectorKey = alreadySelectedProjects.map(project => project.id).filter(id => id !== undefined && id !== null).sort((a, b) => a - b).join('-');
  const selectedBusinessUnitParticipations = localUserAccess.user_access_business_unit_participations || [];
  const alreadySelectedBusinessUnits = selectedBusinessUnitParticipations.map(participation => participation.business_unit).filter(Boolean);
  const businessUnitSelectorKey = alreadySelectedBusinessUnits.map(businessUnit => businessUnit.id).filter(id => id !== undefined && id !== null).sort((a, b) => a - b).join('-');
  const selectedFolderParticipations = localUserAccess.user_access_folder_participations || [];
  const selectedFileParticipations = localUserAccess.user_access_file_participations || [];
  const alreadySelectedFolderIds = selectedFolderParticipations.map(participation => {
    var _participation$folder;
    return ((_participation$folder = participation.folder) === null || _participation$folder === void 0 ? void 0 : _participation$folder.id) || participation.folder_id;
  }).filter(id => id !== undefined && id !== null);
  const alreadySelectedFileIds = selectedFileParticipations.map(participation => {
    var _participation$folder2;
    return ((_participation$folder2 = participation.folder_file) === null || _participation$folder2 === void 0 ? void 0 : _participation$folder2.id) || participation.folder_file_id;
  }).filter(id => id !== undefined && id !== null);
  const selectedFileFolderProjectName = (selectedFileFolderProject === null || selectedFileFolderProject === void 0 ? void 0 : selectedFileFolderProject.project_name) || ((_claimGroup$claim_pro = claimGroup.claim_project_reports) === null || _claimGroup$claim_pro === void 0 || (_claimGroup$claim_pro = _claimGroup$claim_pro.find(project => project.id === (selectedFileFolderProject === null || selectedFileFolderProject === void 0 ? void 0 : selectedFileFolderProject.id))) === null || _claimGroup$claim_pro === void 0 ? void 0 : _claimGroup$claim_pro.project_name) || t('project');
  const selectedFileFolderTarget = selectedFileFolderScope === 'claim_group' ? {
    targetModelId: claimGroup.id,
    type: 'ClaimGroup',
    modelName: claimGroup.name
  } : selectedFileFolderProject ? {
    targetModelId: selectedFileFolderProject.id,
    type: 'ClaimProjectReport',
    modelName: selectedFileFolderProjectName
  } : null;
  const selectAdditionalAccessType = type => {
    setSelectedAditionalAccessType(type);
    setSelectedBusinessUnit(null);
    setSelectedProject(null);
    setSelectedFileFolderScope(null);
    setSelectedFileFolderProject(null);
    setSelectedFileFolderItem(null);
  };
  const selectFileFolderScope = scope => {
    setSelectedFileFolderScope(scope);
    setSelectedFileFolderProject(null);
    setSelectedFileFolderItem(null);
  };
  const createParticipation = async () => {
    setLoading(true);
    try {
      if (selectedBusinessUnit) {
        await createUserAccessBusinessUnitParticipation(localUserAccess, selectedBusinessUnit.id);
      } else if (selectedProject) {
        await createUserAccessProjectParticipation(localUserAccess, selectedProject.id);
      } else if ((selectedFileFolderItem === null || selectedFileFolderItem === void 0 ? void 0 : selectedFileFolderItem.type) === 'folder') {
        await createUserAccessFolderParticipation(localUserAccess, selectedFileFolderItem.item.id);
      } else if ((selectedFileFolderItem === null || selectedFileFolderItem === void 0 ? void 0 : selectedFileFolderItem.type) === 'file') {
        await createUserAccessFileParticipation(localUserAccess, selectedFileFolderItem.item.id);
      }
      const updatedClaimGroup = await claimGroupService.get(claimGroup.id);
      setClaimGroup(_objectSpread({}, updatedClaimGroup));
      const updatedUserAccess = updatedClaimGroup.user_accesses.find(ua => ua.id === userAccess.id);
      if (updatedUserAccess) {
        setLocalUserAccess(updatedUserAccess);
        setClientContact && setClientContact(updatedUserAccess);
      }
      setSelectedBusinessUnit(null);
      setSelectedProject(null);
      setSelectedFileFolderScope(null);
      setSelectedFileFolderProject(null);
      setSelectedFileFolderItem(null);
      onClaimScheduleClientContactParticipationChange && (await onClaimScheduleClientContactParticipationChange());
    } finally {
      setLoading(false);
    }
  };
  const selectBusinessUnit = event => {
    const businessUnitId = Number(event.target.value);
    const isAlreadySelectedBusinessUnit = selectedBusinessUnitParticipations.some(participation => {
      var _participation$busine;
      return ((_participation$busine = participation.business_unit) === null || _participation$busine === void 0 ? void 0 : _participation$busine.id) === businessUnitId;
    });
    setSelectedProject(null);
    setSelectedFileFolderItem(null);
    if (!businessUnitId || isAlreadySelectedBusinessUnit) {
      setSelectedBusinessUnit(null);
      return;
    }
    setSelectedBusinessUnit({
      id: businessUnitId
    });
  };
  const selectClaimProjectReport = event => {
    const projectId = Number(event.target.value);
    const isAlreadySelectedProject = selectedProjectParticipations.some(participation => {
      var _participation$claim_;
      return ((_participation$claim_ = participation.claim_project_report) === null || _participation$claim_ === void 0 ? void 0 : _participation$claim_.id) === projectId;
    });
    setSelectedBusinessUnit(null);
    setSelectedFileFolderItem(null);
    if (!projectId || isAlreadySelectedProject) {
      setSelectedProject(null);
      return;
    }
    setSelectedProject({
      id: projectId
    });
  };
  const selectClaimProjectReportForFileFolder = event => {
    const projectId = Number(event.target.value);
    setSelectedFileFolderItem(null);
    if (!projectId) {
      setSelectedFileFolderProject(null);
      return;
    }
    setSelectedFileFolderProject({
      id: projectId
    });
  };
  const permissionTypes = [{
    value: 'project',
    label: t('project')
  }, {
    value: 'business_unit',
    label: t('business_unit')
  }, {
    value: 'file_folder',
    label: "".concat(t('folder'), " / ").concat(t('file'))
  }];
  const fileFolderScopes = ['claim_group', 'project'];
  const addButtonDisabled = selectedAdditionalAccessType === 'file_folder' ? !selectedFileFolderItem : !selectedBusinessUnit && !selectedProject;
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(DropdownFormField, {
    label: "select_permission_type",
    values: permissionTypes,
    valueFn: permissionType => /*#__PURE__*/React.createElement("option", {
      key: permissionType.value,
      value: permissionType.value
    }, permissionType.label),
    onChange: selectAdditionalAccessType
  })), selectedAdditionalAccessType === 'business_unit' && /*#__PURE__*/React.createElement(Col, {
    md: 5
  }, /*#__PURE__*/React.createElement(BusinessUnitSelector, {
    key: businessUnitSelectorKey,
    companyId: company.id,
    alreadySelectedInstances: alreadySelectedBusinessUnits,
    excludeAlreadySelectedInstances: true,
    onlyActive: true,
    onChange: selectBusinessUnit,
    onBlur: () => {},
    eventFieldName: "business_unit_id"
  })), selectedAdditionalAccessType === 'project' && /*#__PURE__*/React.createElement(Col, {
    md: 5
  }, /*#__PURE__*/React.createElement(ProjectSelector, {
    key: projectSelectorKey,
    claimGroupId: claimGroup.id,
    alreadySelectedInstances: alreadySelectedProjects,
    excludeAlreadySelectedInstances: true,
    onChange: selectClaimProjectReport,
    onBlur: () => {},
    eventFieldName: "claim_project_report_id"
  })), selectedAdditionalAccessType === 'file_folder' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(DropdownFormField, {
    label: "select_document_source",
    values: fileFolderScopes,
    onChange: selectFileFolderScope,
    labelMd: 5
  })), selectedFileFolderScope === 'project' && /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ProjectSelector, {
    claimGroupId: claimGroup.id,
    alreadySelectedInstances: [],
    onChange: selectClaimProjectReportForFileFolder,
    onBlur: () => {},
    onSelectInstance: setSelectedFileFolderProject,
    eventFieldName: "claim_project_report_id"
  }))), selectedAdditionalAccessType && /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement(AddButton, {
    disabled: addButtonDisabled,
    loading: loading,
    className: "mt-1",
    onClick: createParticipation
  })), selectedAdditionalAccessType === 'file_folder' && selectedFileFolderTarget && /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(FolderAndFilePicker
  // The picker initializes its folder from these target values only when it mounts.
  // Remount it when the target changes so project folder state cannot leak into the claim group view.
  , {
    key: "".concat(selectedFileFolderTarget.type, "-").concat(selectedFileFolderTarget.targetModelId, "-").concat(claimGroupRootClientAccessableFolderId),
    claimGroupRootClientAccessableFolderId: claimGroupRootClientAccessableFolderId,
    targetModelId: selectedFileFolderTarget.targetModelId,
    type: selectedFileFolderTarget.type,
    modelName: selectedFileFolderTarget.modelName,
    selectedItem: selectedFileFolderItem,
    onSelect: setSelectedFileFolderItem,
    alreadySelectedFolderIds: alreadySelectedFolderIds,
    alreadySelectedFileIds: alreadySelectedFileIds
  })));
}